import type { ThirdPartySummary } from 'api/cms/thirdPartySummaries';
import { Maybe } from 'monet';

export const findAvailableModal =
  (modalIds: string[] | string) => (summaries: ThirdPartySummary[]) =>
    Maybe.fromEmpty(
      (Array.isArray(modalIds) ? modalIds : [modalIds]).find(
        (level) => !summaries.map(({ modalId }) => modalId).includes(level)
      )
    );
